import { tWithKeyAttr as t } from "../../i18nHelper";
import messageStyles from "./message.module.css";
import defaultAvatar from "../../images/default_avatar.png";
import questionnaireDoctor from "../../images/questionnaire_doctor.png";

import { getTimeFromTimestamp } from "../../utils/utils";
import { IChatMessage } from "../../types/types";
import { useAppSelector } from "../../services/hooks";
import { userSelector } from "../../services/selectors/user.selectors";
import { noDataLabel } from "../../utils/constants";
import { IConversation } from "../../services/types";
import { AppImage } from "../appMedia";

function MessageTest({
  message,
  isOwnMessage,
  activeUser,
  isAI
}: {
  message: IChatMessage;
  isOwnMessage: boolean;
  activeUser: IConversation;
  isAI?: boolean
}) {
  const messageClassname = isOwnMessage
    ? `${messageStyles.message} ${messageStyles.ownMessage}`
    : messageStyles.message;
  const containerClassname = isOwnMessage
    ? messageStyles.ownMessageContainer
    : messageStyles.messageContainer;

  const therapist = useAppSelector(userSelector);

 const avatar = isOwnMessage
  ? therapist.avatar ?? questionnaireDoctor
  : isAI
    ? questionnaireDoctor
    : activeUser.appointment?.users?.avatar ?? defaultAvatar;

const alt = isOwnMessage
  ? therapist.FirstName
  : isAI
    ? "AI"
    : noDataLabel;



  return (
    <>
      <div className={containerClassname}>
        <AppImage src={avatar} alt={alt} className={messageStyles.avatar} />
        <div className={messageClassname}>
          <p className={messageStyles.text} data-testid={isOwnMessage ? "therapist-message-text" : "client-message-text"}>
            {message.content?.split("\n").map((part, index) => (
              <span key={index} className={messageStyles.textPart}>
                {part}
              </span>
            ))}
          </p>
          <p
            className={`${messageStyles.time} ${isOwnMessage && messageStyles.time_ownMessage
              }`}
            data-testid={isOwnMessage ? "therapist-message-time" : "client-message-time"}
          >
            {message.sentDate ? getTimeFromTimestamp(message.sentDate) : ""}
          </p>
        </div>
      </div>
    </>
  );
}

export default MessageTest;
